import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { booleanConverter } from "../../common/converters";

@customElement('mhecomm-date-label')
export class DateLabel extends LitElement {

    static styles = [css`
        .date-label-text {
            font-weight: normal;
            font-style: italic;
        }
        .date-label-date {
            font-weight: bold;
            font-style: italic;
        }
    `];

    @property()
    text?: string;

    @property()
    duration?: string;

    @property()
    period?: string;

    @property({ converter: booleanConverter })
    applyStyles = false;

    private expireDate?: string;

    connectedCallback() {
        super.connectedCallback();

        const currentDate = new Date();
        if (this.duration) {
            if (this.period === 'Day') {
                currentDate.setDate(currentDate.getDate() + parseInt(this.duration));
            } else if (this.period === 'Month') {
                currentDate.setMonth(currentDate.getMonth() + parseInt(this.duration));
            } else if (this.period === 'Year') {
                currentDate.setFullYear(currentDate.getFullYear() + parseInt(this.duration));
            }
            this.expireDate = currentDate.toLocaleDateString('en-US');
        } else {
            const options = { month: 'short', day: 'numeric' };
            this.expireDate = `Today, ${currentDate.toLocaleDateString('en-US', options)}`;
        }
    }
    render() {
        return html`
            <span class="${this.applyStyles ? 'label-text' : 'date-label-text'}">${this.text}</span>
            <span class="${this.applyStyles ? 'label-date' : 'date-label-date'}">${this.expireDate}</span>
        `;
    };
}

declare global {
    interface HTMLElementTagNameMap {
        'mhecomm-date-label': DateLabel;
    }
}